import React, { Component, Fragment } from 'react';
import Header from '../../global_components/Header';
import getDefaultCommunicationTerms from '../../helpers/communicationTermsDefaultTemplate';

export class CommunicationTerms extends Component {

	componentDidMount() {
		const { business, globalError } = this.props;
		document.title = `${business.client_name} - Communication Terms`;

		if (!business?.cyberSettings?.communication_terms_enabled) {
			globalError('This business has not published a communication terms page. If you are the business owner and would like to enable this, visit your CyberOffice settings.');
		}
	}

	render() {
		const { business } = this.props;
		const { communication_terms_use_default, custom_communication_terms } = business?.cyberSettings || {};
		const content = (communication_terms_use_default || !custom_communication_terms)
			? getDefaultCommunicationTerms(business.client_name)
			: custom_communication_terms;

		return (
			<Fragment>
				<Header head="SMS & Automated Call Terms" subHead={ `How ${ business.client_name } communicates with you by text message and phone.` } />
				<div className="customTermsCard communicationTermsCard">{ content }</div>
			</Fragment>
		);
	}
}

export default CommunicationTerms;
